import { getInitialsName } from '@repo/ui';
import { useAuth } from 'presentation/app/hooks/useAuth';
import { useState } from 'react';
import { Spinner } from 'reactstrap';

import { userProfile } from '../../hooks/userProfile';

interface IPersonProfile {
  name?: string;
  photo?: string;
  classPhoto: string;
}

const ProfilePhoto = ({ classPhoto, name, photo }: IPersonProfile) => {
  // Hooks
  const { requestUpdateProfile, loadingUpdateProfile } = userProfile();
  const { currentUser } = useAuth();

  const [newFile, setNewFile] = useState();

  const handleClick = () => {
    document.getElementById('fileInput').click();
  };

  const allowedFileTypes = ['image/png', 'image/jpg', 'image/jpeg'];

  const handleFileChange = (event) => {
    const uploadedFile = event.target.files?.[0];
    const maxAllowedSize = 5 * 1024 * 1024; // 5 MegaBytes

    const file = event.target.files[0];
    if (
      !file ||
      !uploadedFile ||
      !(uploadedFile instanceof File) ||
      !allowedFileTypes.includes(uploadedFile.type) ||
      !(uploadedFile.size <= maxAllowedSize)
    ) {
      alert(
        'Apenas arquivos .png, .jpg e .jpeg são aceitos e devem ser menores que 5 MB.',
      );
      return;
    }

    const reader = new FileReader();

    reader.onloadend = () => {
      const base64String = reader.result as unknown as string;
      setNewFile(base64String as any);
      requestUpdateProfile({ id: currentUser.id, photo: base64String });
      // requestGetByIdProfile({ id: currentUser.id });
    };

    reader.readAsDataURL(file);
  };

  return (
    <div
      className="d-flex align-items-center"
      onClick={handleClick}
      style={{ position: 'relative', cursor: 'pointer' }}
    >
      {loadingUpdateProfile ? (
        <div
          style={{
            position: 'absolute',
            top: '0px',
            left: '0px',
            right: '0px',
            bottom: '0px',
            background: 'rgba(0, 0, 0, 0.5)',
            borderRadius: '50%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Spinner size="md" className=" text-white">
            {['Carregando...']}
          </Spinner>
        </div>
      ) : null}
      {photo || newFile ? (
        <img
          src={newFile || photo}
          className={`${classPhoto} justify-content-center align-content-center`}
        />
      ) : (
        <div
          style={{ background: '#144c5b' }}
          className={`${classPhoto} justify-content-center align-content-center`}
        >
          <span className="fs-3 text-light">{getInitialsName(name || '')}</span>
        </div>
      )}

      <div
        style={{
          position: 'absolute',
          bottom: '0px',
          right: '0px',
          borderRadius: '50%',
          width: '40px',
          height: '40px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          background: '#333',
        }}
        className=" d-flex border border-muted border-3"
      >
        <i className="ri-camera-2-fill text-white"></i>
      </div>
      <input
        type="file"
        id="fileInput"
        style={{ display: 'none' }}
        accept="image/*"
        onChange={handleFileChange}
      />
    </div>
  );
};

export default ProfilePhoto;
